var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-full-a", attrs: { id: "category" } }, [
    _c("div", { staticClass: "body full-task-main" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.categoryIdSearch,
                  expression: "categoryIdSearch"
                }
              ],
              staticClass: "form-control show-tick",
              attrs: { id: "categoryData" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.categoryIdSearch = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("label", { attrs: { for: "categories" } }, [
                _vm._v("Category")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "" } }, [_vm._v("Please select")]),
              _vm._v(" "),
              _vm._l(_vm.categoryArr, function(categoryData, index) {
                return [
                  _c("option", { domProps: { value: categoryData.value } }, [
                    _vm._v(_vm._s(categoryData.text))
                  ])
                ]
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" }),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: {
              id: "categoryForm",
              enctype: "multipart/form-data",
              method: "post"
            }
          },
          [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
              [
                _c("br"),
                _vm._v(" "),
                _c("vue-dropzone", {
                  ref: "dropzone",
                  attrs: {
                    id: "drop1",
                    options: _vm.dropzoneOptions,
                    headers: _vm.dropzoneOptions.headers
                  },
                  on: {
                    "vdropzone-complete": _vm.afterComplete,
                    "vdropzone-removed-file": _vm.removedSelectedFile
                  }
                }),
                _vm._v(" "),
                _c("font", { staticClass: "text-danger" }, [
                  _c("strong", {
                    staticClass: "error text-danger",
                    attrs: { id: "errorMsg" }
                  })
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "mediaSource" } }, [
                    _vm._v("Media Source")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-line" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mediaSource,
                          expression: "mediaSource"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "mediaSource",
                        name: "mediaSource",
                        placeholder: "Enter Media Source"
                      },
                      domProps: { value: _vm.mediaSource },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.mediaSource = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    staticClass: "btn btn-primary",
                    attrs: { id: "addMedia", type: "submit", value: "Save" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.submitFile()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.removeAllFiles }
                    },
                    [_vm._v("Remove File")]
                  )
                ])
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20cd5da1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cd5da1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/gallery/AddVideos.vue
// module id = null
// module chunks = 